module.exports = {
      id: "gears-usage",
      viewBox: "0 0 100 100",
      url: __webpack_public_path__ + "svg-sprite-4990048fd6d3fd501089a0638bd441f8.svg#gears",
      toString: function () {
        return this.url;
      }
    }